<template>
  <van-loading type="spinner" vertical>加载中...</van-loading>
</template>

<script>
import { reactive, toRefs } from 'vue'

export default {
  setup() {
    const state = reactive({
      count: 0
    })

    return {
      ...toRefs(state)
    }
  }
}
</script>

<style lang="scss" scoped>
.van-loading {
  margin-top: 30vh;
}
</style>
